import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListPartners = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_PARTNERS'})
}

export const unmountDetailPartner = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_PARTNERS'})
}

export const unmountMasterPartners = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_PARTNERS'})
}

export const listPartners = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_PARTNERS' })
  return API.GET('/partners/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_PARTNERS_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_PARTNERS_FAILED' }), 
    ))
  })
}

export const detailPartner = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_PARTNERS' })
  const params = {
    'id': id
  }
  API.GET('/partners/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_PARTNERS_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_PARTNERS_FAILED' }), 
      ))
    )
  })
}

export const masterPartners = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_PARTNERS' })
  return API.GET('/partners_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_PARTNERS_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_PARTNERS_FAILED' }), 
    ))
  })
}

export const createPartner = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/partners/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editPartner = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/partners/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enablePartner = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/partners/enableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disablePartner = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/partners/disableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}